import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { FullScreenLoading } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import {
  selectIsFeatureFlagEnabled,
  FEATURE_FLAGS,
} from '@backrs_ui/grow-ui/src/redux/featureFlags/featureFlags';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import { selectUserId } from '@backrs_ui/grow-ui/src/redux/user/user';

import { SharedSessionGrantsPage } from './SharedSessionGrantsPage';

export const SharedSessionGrantsPageContainer = () => {
  const userId = useAppSelector(selectUserId);
  const navigate = useNavigate();
  const flagValues = useAppSelector((state) => state.featureFlags.flagValues);
  const isSharedSessionGrantsEnabled = useAppSelector(
    selectIsFeatureFlagEnabled(FEATURE_FLAGS.SHARED_SESSION_GRANTS),
  );

  const flagExists = FEATURE_FLAGS.SHARED_SESSION_GRANTS in flagValues;

  useEffect(() => {
    if (flagExists && !isSharedSessionGrantsEnabled) {
      navigate(APP_ROUTE.HOME);
    }
  }, [flagExists, isSharedSessionGrantsEnabled, navigate]);

  if (!userId || !flagExists || !isSharedSessionGrantsEnabled) {
    return <FullScreenLoading />;
  }

  return <SharedSessionGrantsPage />;
};
